export default __webpack_public_path__ + "static/legal-8f1c848be3f1acc5125d175440501f64.svg";